import { EGiftType, IItemGiftInfo } from "@interfaces/user/daily";
import { FC } from "react";
import Text from "../../Text";
import { useDailyGiftContext } from "./context";

const DailyGiftItemCount: FC = (props) => {
    const gift = useDailyGiftContext();

    if (gift?.giftType !== EGiftType.ItemGift) {
        return null;
    }

    return (
        <Text text={(gift.giftInfo as IItemGiftInfo).count} {...props} />
    )
}

export default DailyGiftItemCount;
